const NewIcon = ({ width, height, color }) => {
    const iconWidth = width ?? 14;
    const iconHeight = height ?? 14;
    const fillColor = color ?? "#FF4444";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={iconWidth}
            height={iconHeight}
            viewBox="0 0 24 24"
            style={{ display: 'inline-block' }}
        >
            <circle cx="12" cy="12" r="11" fill={fillColor} />
            <text
                x="12"
                y="17"
                fontSize="8"
                fontWeight="bold"
                fill="white"
                textAnchor="middle"
                fontFamily="Arial, sans-serif"
            >
                NEW
            </text>
        </svg>
    );
};

export default NewIcon;

